import MessageBox from './MessageBox.vue'
import { IKDMessageBoxOptions as Options } from 'kuaidong-model'

export default class {
  public result: Promise<boolean>

  private options: Partial<Options> = {
    title: '提示',
    message: '',
    html: false,
    showCloseIcon: false,
    showConfirmButton: true,
    showCancelButton: false,
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    confirmButtonType: 'primary',
    confirmButtonStyle: {},
    cancelButtonType: 'secondary',
    cancelButtonStyle: {},
    closeOnClickModal: true,
    landscapeFit: false,
    onAdditionalButton: null,
    showAdditionalButton: false,
    additionalButtonText: '确定',
  }

  private instance: Vue

  constructor(options?: Partial<Options>) {
    this.options = Object.assign({}, this.options, options)

    this.instance = new MessageBox({
      el: document.createElement('div'),
      data: this.options,
    })

    this.result = new Promise((resolve) => {
      this.instance.$on('cancel', () => resolve(false))
      this.instance.$on('confirm', () => resolve(true))
      this.instance.$on('close', () => resolve(null as any)) // 非模态点去关闭
    })

    document.body.appendChild(this.instance.$el)
  }

  public close() {
    this.instance.$destroy()
  }

  public static alert(message?: string, title = '提示', options?: Partial<Options>): Promise<boolean | null> {
    return new this(Object.assign({}, options, { title, message, showCancelButton: false })).result as any
  }

  // 注意，实际会返回 true/false/null这三种情况
  public static confirm(message?: string, title = '提示', options?: Partial<Options>): Promise<boolean | null> {
    return new this(Object.assign({}, options, { title, message, showCancelButton: true })).result as any
  }
}
